/**
 * Outpost service — OutpostForge frontend (CES standard)
 * Inventory reads: outposts, assets, running instances, instance types.
 */

import type {
  ListAssetsResponse,
  ListInstancesResponse,
  ListInstanceTypesResponse,
  ListOutpostsResponse,
} from '../../types/outposts';
import { http } from '../http';

export const outpostService = {
  async getOutposts(): Promise<ListOutpostsResponse> {
    const response = await http.get<ListOutpostsResponse>('/outposts');
    return response.data;
  },

  async getAssets(outpostId: string): Promise<ListAssetsResponse> {
    const response = await http.get<ListAssetsResponse>(
      `/outposts/${encodeURIComponent(outpostId)}/assets`,
    );
    return response.data;
  },

  async getInstances(outpostId: string, assetId?: string): Promise<ListInstancesResponse> {
    const query = assetId ? `?assetId=${encodeURIComponent(assetId)}` : '';
    const response = await http.get<ListInstancesResponse>(
      `/outposts/${encodeURIComponent(outpostId)}/instances${query}`,
    );
    return response.data;
  },

  async getInstanceTypes(
    outpostId: string,
    assetId?: string,
  ): Promise<ListInstanceTypesResponse> {
    const query = assetId ? `?assetId=${encodeURIComponent(assetId)}` : '';
    const response = await http.get<ListInstanceTypesResponse>(
      `/outposts/${encodeURIComponent(outpostId)}/instance-types${query}`,
    );
    return response.data;
  },
};

export type OutpostService = typeof outpostService;
